const yup = require('yup')
const { requiredFields, labelify } = require('./helpers')
const { uploadSchema: cloudinaryUploadSchema } = require('./cloudinary-schema')
const { uploadSchema } = require('./s3-schema')
const mobileUserTypes = require('../mobile-user-types')
const displayLocation = require('./fields/display-location')
const scheduleDate = require('./fields/schedule-date')
const { dailySchedules } = require('./fields/daily-schedules')
const scheduleDateTime = require('./fields/schedule-datetime')

const imageSchema = yup.object().shape({
  description: yup.string().ensure(),
  image: uploadSchema,
  cloudinaryFile: cloudinaryUploadSchema,
})

const shape = labelify({
  restrictToUsers: yup.array().default([]),
  restrictToUserType: yup.string().oneOf(mobileUserTypes.concat('')).ensure(),
  name: yup.string().default(''),
  media: yup.array().of(imageSchema).default([]),
  duration: yup.number().default(15),
  schedule: yup.string().oneOf(['immediate', 'scheduled', 'event']).default('immediate'),
  scheduleAt: scheduleDate(),
  scheduleEndAt: scheduleDate(),
  dailySchedules: dailySchedules(),
  appearance: yup
    .string()
    .when('contentSource', { is: 'embed', then: (s) => s.oneOf(['normal', 'maximized', 'fullscreen']), otherwise: (s) => s.oneOf(['normal', 'maximized']) })
    .default('normal'),
  displayLocation: displayLocation(),
  filterDevices: yup.string().oneOf(['all', 'selected', 'none']).default('all'),
  devices: yup.array().of(yup.string()).default([]),
  mediaPerPage: yup.number().min(1).max(9).default(7),
  createdAt: yup.date(),
  updatedAt: yup.date(),
  createdBy: yup.mixed(),
  updatedBy: yup.mixed(),
  sortOrder: yup.number().min(0).transform((v) => Math.max(v, 0)),
  enableDesignHuddleSync: yup.boolean().nullable().default(false),
  published: yup.boolean().nullable().default(true),
})

const albumSchemaPartial = yup.object().shape(shape)
const albumSchema = albumSchemaPartial.shape(requiredFields(['name'])(shape))
const albumFormSchema = albumSchema.shape({
  scheduleAt: scheduleDateTime(),
  scheduleEndAt: scheduleDateTime(),
})

module.exports = { albumSchema, albumSchemaPartial, albumFormSchema }
